define('lq/highlighter',[
    'jquery'
], function ($) {
    'use strict';

    var $highlight;

    var highlight = function ($element) {
        if (!$highlight) {
            $highlight = $('<div />')
                .addClass('highlighter')
                .appendTo($('body'))
        } else {
            $highlight.removeClass('highlighter-flash');
        }

        setTimeout(function () {
            var rect = $element[0].getBoundingClientRect();

            $highlight
                .addClass('highlighter-flash')
                .css({
                    top: rect.top + 'px',
                    left: rect.left + 'px',
                    height: rect.height + 'px',
                    width: rect.width + 'px'
                });
        });
    };

    return {
        highlight: highlight
    };
});
